import React from "react";
import SEO from '../components/seo';
import Layout from "../components/layout";
import ImageRetail from "../images/industries-retail-image.jpg";
import ImageManufacturing from "../images/industries-manufacturing-image.jpg";
import ImagLogistic from "../images/industries-logistic-image.jpg";
import ImagHealthcare from "../images/industries-healthcarel-image.jpg";
import StickyCTA from "../components/common/templates/sticky-cta-section";

import { Link } from 'gatsby';

const WorkPage = ({ location }) => (
    <Layout addBodyClass="work-page transparent-header" footerFormType="basic">
        <SEO description="Rapidops help various industries to embrace digital transformation opportunities."
            meta={[{ name: "charSet", content: "utf-8" }]}
            title="Industries we serve - Rapidops" />
        <div className="work-landing-page">
            <div className="container">
                <div className="section-gap-small title-bar">
                    <h1>All Industries</h1>
                    <p className="sub-title">Embrace the opportunity and be future-ready with  digital transformation</p>
                </div>

                <div className="work-grid section-gap-large">
                    <div className="row d-flex flex-wrap">
                        <div className="col mobile-hide">
                            <div className="work-grid-item">
                                <div className="work-grid-item-image ht-img"><Link to="/industries/retail/">
                                    <img src={ImageRetail} title="Industries Retail" alt="Industries Retail" />
                                </Link></div>
                                <h3><Link to="/industries/retail/">Retail</Link></h3>
                                <p>Enabling digital experiences for retail & FMCG consumer experiences</p>
                            </div>
                            <div className="work-grid-item">
                                <div className="work-grid-item-image salesmate-img">
                                    <Link to="/industries/logistics/">
                                        <img src={ImagLogistic} title="Industries Logistic" alt="Industries Logistic" />
                                    </Link>
                                </div>
                                <h3><Link to="/industries/logistics/">Supply Chain & Logistics</Link></h3>
                                <p>Digitize supply chains, reduce risks, and optimize cost</p>
                            </div>
                        </div>
                        <div className="col mobile-hide">
                            <div className="work-grid-item">
                                <div className="work-grid-item-image kroger-img"><Link to="/industries/manufacturing/">
                                    <img src={ImageManufacturing} alt="Industries Retail" title="Industries Retail" />
                                </Link></div>
                                <h3><Link to="/industries/manufacturing/">Manufacturing</Link></h3>
                                <p>Build smart factories, deploy IOT, and automate processes</p>
                            </div>  
                            <div className="work-grid-item">
                                <div className="work-grid-item-image flexprint-img"><Link to="/industries/healthcare/">
                                    <img src={ImagHealthcare} title="Industries Retail" alt="Industries Retail" />
                                </Link></div>
                                <h3><Link to="/industries/healthcare/">Healthcare</Link></h3>
                                <p>Reshaping the patient experiences and future of healthcare</p>
                            </div>
                        </div>
                        <div className="col mobile-show">
                            <div className="work-grid-item">
                                <div className="work-grid-item-image ht-img"><Link to="/industries/retail/">
                                    <img src={ImageRetail} title="Industries Retail" alt="Industries Retail" />
                                </Link></div>
                                <h3><Link to="/industries/retail/">Retail</Link></h3>
                                <p>Enabling digital experiences for retail & FMCG consumer experiences</p>
                            </div>

                            <div className="work-grid-item">
                                <div className="work-grid-item-image kroger-img"><Link to="/industries/manufacturing/">
                                    <img src={ImageManufacturing} alt="Industries Retail" title="Industries Retail" />
                                </Link></div>
                                <h3><Link to="/industries/manufacturing/">Manufacturing</Link></h3>
                                <p>Build smart factories, deploy IOT, and automate processes</p>
                            </div> 

                            <div className="work-grid-item">
                                <div className="work-grid-item-image salesmate-img">
                                    <Link to="/industries/logistics/">
                                        <img src={ImagLogistic} title="Industries Logistic" alt="Industries Logistic" />
                                    </Link>
                                </div>
                                <h3><Link to="/industries/logistics/">Supply Chain & Logistics</Link></h3>
                                <p>Digitize supply chains, reduce risks, and optimize cost</p>
                            </div>

                            <div className="work-grid-item">
                                <div className="work-grid-item-image flexprint-img"><Link to="/industries/healthcare/">
                                    <img src={ImagHealthcare} title="Industries Retail" alt="Industries Retail" />
                                </Link></div>
                                <h3><Link to="/industries/healthcare/">Healthcare</Link></h3>
                                <p>Reshaping the patient experiences and future of healthcare</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <FormSection location={location} className="site-footer-form" id="form-section" /> */}
        {/* <StickyCTA /> */}
    </Layout>
);

export default WorkPage;
